<div class="body audit-body">
    
    <div class="section" *ngIf="(createdFiles$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">add</mat-icon>
            <span class="text">Dateien hinzugefügt</span>
            <span class="counter">{{(createdFiles$|async)?.length}}</span>

        </div>

        <div class="entry">

            <app-file-list-entry *ngFor="let file of (createdFiles$|async)" [file]="{href:file.nextcloudHref}"></app-file-list-entry>

        </div>

    </div>

    <div class="section" *ngIf="(movedFiles$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">edit</mat-icon>
            <span class="text">Dateien umbenannt</span>
            <span class="counter">{{(movedFiles$|async)?.length}}</span>

        </div>

    </div>

    <div class="section" *ngIf="(deletedFiles$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">clear</mat-icon>
            <span class="text">Dateien gelöscht</span>
            <span class="counter">{{(deletedFiles$|async)?.length}}</span>

        </div>

    </div>

</div>